import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from 'typeorm';

@Entity('workers')
export class WorkerEntity {
  @PrimaryGeneratedColumn('increment', { name: 'worker_id' })
  workerId: number;

  @Column('varchar', {
    nullable: false,
    length: 50,
    name: 'worker_code',
  })
  workerCode: string;

  @Column('varchar', {
    nullable: false,
    length: 100,
    name: 'worker_name',
  })
  workerName: string;

  @Column('varchar', {
     nullable: true,
    length: 30,
    name: 'aadhar_card_no',
  })
  aadharCardNumber: string;

  @Column({
    nullable: true,
    name: "date_of_birth"
  })
  dateOfBirth: Date;


  @Column('text', {
    nullable: true,
    name: 'address',
  })
  address: string;

  @Column('varchar', {
    nullable: false,
    length: 100,
    name: 'village_from',
  })
  villageFrom: string;


  @Column('int', {
    nullable: false,
    name: 'contractor_id',
  })
  contractorId: number;


  @Column('varchar', {
    nullable: false,
    length:100,
    name: 'contractor_name',
  })
  contractorName: string;


  @Column({
    nullable: false,
    name: "date_of_joining"
  })
  dateOfJoining: Date;

  
  @Column('int', {
    nullable: false,
    name: 'village_from_id',
  })
  villageFromId: number;


  @Column("boolean", {
    nullable: false,
    default: true,
    name: "is_active"
  })
  isActive: boolean;


  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "created_user"
  })
  createdUser: string | null;


  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user"
  })
  updatedUser: string | null;


  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;



}
